import { addFlashAlert } from "common/components/FlashAlert";
import { Serwist } from "@serwist/window";

const serviceWorkerExpiration = 1800000;

export const setupServiceWorker = async (globalNavigator: Navigator) => {
  if ("serviceWorker" in globalNavigator) {
    try {
      const serwist = new Serwist("/v2/service-worker.js", { scope: "/v2/", type: "classic" });

      void serwist.register();
    } catch (error) {
      console.error("ServiceWorker registration failed", error);
    }
  }
};

export const checkForUpdate = (globalNavigator: Navigator, globalWindow: Window, globalLocalStorage: Storage): void => {
  if (!globalNavigator.serviceWorker.controller) {
    console.error("No service worker controller found, do nothing");
    return;
  }

  const expiration = globalLocalStorage.getItem("serviceWorkerUpdateExpiration");
  const path = globalWindow.location.pathname;

  if (!path.includes("screen_shares") || path.includes("join")) {
    if (expiration) {
      const expirationDate = new Date(parseInt(expiration, 10));
      const now = new Date();

      if (now > expirationDate) {
        showUpdateMessage(globalLocalStorage);
      }
    } else {
      showUpdateMessage(globalLocalStorage);
    }
  } else {
    globalLocalStorage.setItem("serviceWorkerUpdateExpiration", (Date.now() + serviceWorkerExpiration).toString());
  }
};

export const showUpdateMessage = (globalLocalStorage: Storage) => {
  globalLocalStorage.setItem("serviceWorkerUpdateExpiration", (Date.now() + serviceWorkerExpiration).toString());
  addFlashAlert("update");
};

export const clearWorkers = async (): Promise<void> => {
  const registrations = await navigator.serviceWorker.getRegistrations();

  registrations.forEach((registration) => {
    registration.unregister();
  });

  const cacheNames = await caches.keys();
  cacheNames.forEach((cacheName) => {
    caches.delete(cacheName);
  });

  window.location.reload();
};
